import enamelPins from "@/assets/enamel-pins.jpg";
import artsyPrint from "@/assets/artsy-print.jpg";
import parkRowHat from "@/assets/park-row-hat.jpg";
import parkRowTshirt from "@/assets/park-row-tshirt.jpg";
import texasHoodie from "@/assets/texas-hoodie-navy-final.jpg";

export interface Product {
  id: number;
  name: string;
  price: number;
  image: string;
  category: string;
  description: string;
  sizes?: string[];
  inStock: boolean;
}

export const products: Product[] = [
  {
    id: 1,
    name: "Livin' T-Shirt",
    price: 29.99,
    image: parkRowTshirt,
    category: "Apparel",
    description: "Premium cotton tee with the iconic Park Row 'Livin' design. Soft, comfortable, and perfect for any occasion.",
    sizes: ["S", "M", "L", "XL", "2XL"],
    inStock: true,
  },
  {
    id: 2,
    name: "Park Row Texas Hoodie",
    price: 64.99,
    image: texasHoodie,
    category: "Apparel",
    description: "Stay warm in style with our heavyweight Texas hoodie. Features embroidered Park Row logo and ultra-soft fleece lining.",
    sizes: ["S", "M", "L", "XL", "2XL"],
    inStock: true,
  },
  {
    id: 3,
    name: "Limited Edition Vinyl Records",
    price: 39.99,
    image: "https://images.unsplash.com/photo-1603048588665-791ca8aea617?w=400&h=400&fit=crop",
    category: "Music",
    description: "Collector's edition vinyl featuring our latest album. Limited run of 500 copies with exclusive artwork.",
    inStock: true,
  },
  {
    id: 4,
    name: "Park Row Hat",
    price: 24.99,
    image: parkRowHat,
    category: "Accessories",
    description: "Classic snapback with embroidered Park Row logo. Adjustable fit for all head sizes.",
    inStock: true,
  },
  {
    id: 5,
    name: "200 Edition Prints",
    price: 147.50,
    image: artsyPrint,
    category: "Collectibles",
    description: "Museum-quality giclée print on archival paper. Signed and numbered, limited to 200 pieces worldwide.",
    inStock: true,
  },
  {
    id: 6,
    name: "Collectible Enamel Pins",
    price: 19.99,
    image: enamelPins,
    category: "Collectibles",
    description: "Set of 3 hard enamel pins featuring Park Row iconography. Perfect for jackets, bags, and more.",
    inStock: true,
  },
];
